import { LineData, UTCTimestamp } from "lightweight-charts"
import { ListFundingRatesReturn } from "service/appSync/FundingRateService"

export const parseFundingRates = (rawData: ListFundingRatesReturn["items"]): LineData[] =>
    rawData.map(({ fundingRate, timestamp }, index) => {
        return {
            value: Number(fundingRate) * 100, // NOTE: convert to percentage
            time: timestamp as UTCTimestamp,
        }
    })
